export const UPDATE_USER = 'reducers/global/user/update_user'



// WEBPACK FOOTER //
// ./src/reducers/global/user/constants.js